export default __webpack_public_path__ + "static/wave_header-31a98c03cee07b0f8319065c97242cf6.png";